import { DashOtif } from "../../../components/classes/DashOtif";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import { IconButton, Modal, Tooltip } from "@mui/material";
import { Download } from "@mui/icons-material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import DownloadCSVModal from "../../../components/common/DownloadCSVModal/DownloadCSVModal";
import { DashParceirosModel } from "../../../components/classes/DashParceiros";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function DashboardAcompParceirosGrid(
    props: DashboardAcompParceirosGridPropsTypes
) {
    const { t } = useTranslation();

    const [rows, setRows] = useState<Data>([]);
    const [openDownloadCSVModal, setOpenDownloadCSVModal] = useState<boolean>(false);

    const columns: GridColumns = [
        {
            field: "id",
            headerName: t("common.id"),
            width: 80,
            align: "center",
            headerAlign: "center",
            renderHeader: (item) => {
                return <div>#</div>;
            },
        },
        {
            field: "descricaoFornecedorSap",
            headerName: t("common.partner"),
            type: "string",
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "dia",
            headerName: t("common.date"),
            type: "date",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
            },
        },
        {
            field: "semana",
            headerName: t("common.week"),
            type: "date",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return <p>{`Semana ${item.value}`}</p>;
            },
        },
        {
            field: "numeroContrato",
            headerName: t("common.contract"),
            type: "string",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "sku",
            headerName: t("common.sku"),
            type: "string",
            width: 110,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "descricao",
            headerName: t("common.description"),
            type: "string",
            width: 320,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "quantidadePlanejada",
            headerName: t("common.plannedQuantity"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "quantidadeEntregue",
            headerName: t("common.deliveredQuantity"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "justificativa",
            headerName: t("common.justification"),
            type: "string",
            width: 280,
            editable: false,
            align: "center",
            headerAlign: "center",
        }
    ];

    useEffect(() => {
        if (props.data) {
            fillTable();
        }
    }, [props]);

    const fillTable = () => {
        let gridData: Data = [];
        props.data?.forEach(
            (item: DashParceirosModel, index: number) => {
                let json = JSON.parse(DashParceirosModel.toJson(item));
                json.id = index;
                gridData.push(json);
            }
        );
        setRows(gridData);
    }

    return (
        <div style={{ height: "60vh", width: "100%", marginTop: 15 }}>
            <div className="containerToolbar">
                <Tooltip title={t("pages.dashboardTracking.text.downloadCsvFile")}>
                    <span>
                        <IconButton onClick={() => setOpenDownloadCSVModal(true)}>
                            <Download />
                        </IconButton>
                    </span>
                </Tooltip>
            </div>
            <DataGrid
                rows={rows}
                columns={columns}
                rowsPerPageOptions={[50, 100, 250, 500]}
            />

            <Modal
                open={openDownloadCSVModal}
                onClose={() => setOpenDownloadCSVModal(false)}
                sx={{
                    display: "flex",
                    "justifyContent": "center",
                    "alignItems": "center",
                }}
            >
                <>
                    <DownloadCSVModal
                        handleClose={() => setOpenDownloadCSVModal(false)}
                        rows={rows}
                        columns={columns}
                        name={t("pages.dashboardTracking.pageTitle")}
                    />
                </>
            </Modal>
        </div>
    );
}

interface DashboardAcompParceirosGridPropsTypes {
    data?: DashParceirosModel[]
}